export default __webpack_public_path__ + "static/media/bundle-guide-us-white@3x.9203b7ab.jpg";